import AuthorizedElement from "@/common/components/Auth/AuthorizedElement";
import { ChatMessageCounterChip } from "@/common/components/Entity/ChatMessage/ChatMessageCount";
import AppNavIcon from "@/common/components/Icons/AppNavIcon";
import AppNavItem from "@/common/components/Nav/AppNavItem";
import { FeatureName } from "@/common/constants/featureName";
import { ROUTE_PATH } from "@/common/constants/routing";
import { useCommunicationCounters } from "@/common/hooks/communication/useCommunicationCounters";
import { featureManager } from "@/config/features";
import { AppPermission } from "@/core/api/generated/v1";

import { AppNavToNavItemParams } from "../Nav";

interface Props {
  navParams: AppNavToNavItemParams;
}

export default function InboxItemGroup({ navParams }: Props) {
  const counters = useCommunicationCounters({
    isEnabled: featureManager.isEnabled(FeatureName.ChatMessageUnreadCounter),
  });
  const unreadMessageCount = counters?.chatMessages?.unreadCount ?? 0;

  return (
    <AuthorizedElement permissions={[AppPermission.FleetAppAccess]}>
      <AppNavItem
        type='item'
        item={{
          startIcon: <AppNavIcon of='inbox' />,
          content: "Inbox",
          to: ROUTE_PATH.INBOX(),
          isCountersEnabled: featureManager.isEnabled(FeatureName.ChatMessageUnreadCounter),
          counters: [
            {
              title: "Unread messages",
              counter: counters?.chatMessages?.unreadCount,
            },
            {
              title: "Unread chats",
              counter: counters?.chats?.unreadCount,
            },
          ],
          onClick: navParams.onItemClick,
          renderCounter: () => (
            <ChatMessageCounterChip count={unreadMessageCount} isShowEmpty={false} size='small' />
          ),
        }}
      />
    </AuthorizedElement>
  );
}
